import { ActivityFilter } from '@shared/models/filter.model';
export interface PopularFilter extends ActivityFilter {
  popularFilterType?: 'benefits' | 'adyenInstalments';
}
export interface HotelFilterForm {
  hotelName: string;
  priceRange: [number, number, string];
  starRating: ActivityFilter[];
  amenities: ActivityFilter[];
  popularFilters: PopularFilter[];
}

export const hotelDefaultFilterForm: HotelFilterForm = {
  hotelName: '',
  priceRange: [0, 0, 'min'],
  starRating: [],
  amenities: [],
  popularFilters: [],
};
